import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class DiscountTriggerSearchForm extends SearchComponent {
  searchInputs = [
    {
      name: 'name',
      label: 'common:label.name',
    },
    {
      name: 'evaluationComponent',
      label: 'common:label.evaluationComponent',
      type: 'select',
      tOptions: 'selections:evaluationComponent',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-6';
}

DiscountTriggerSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

DiscountTriggerSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(DiscountTriggerSearchForm);
